import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../../store";
import { LogoSmall, LogoDark } from "../Assets";
import { CHARGERS, FUEL, POWER_GENERATION, POWER_DIAG } from "../../../utils/constants";
import { capitalizeFirstLetter } from "../../../utils/common";
import { useMenuItems } from "./useMenuItems";
import { useMenuHandlers } from "./useMenuHandlers";

export function useSidebarLogic(presentComponents: any, isNewIndustry: boolean) {
    const location = useLocation();
    const { collapsed } = useSelector((state: RootState) => state.userInfo);
    const { chargerId: chargerIdFromURL, powerId: powerIdFromURL, fuelId }: any = useParams();

    const { handleChargerMenuItemClick, handleMenuItemClick, chargerMenuItems } = useMenuHandlers();

    const menuItems = useMenuItems({
        presentComponents,
        chargerMenuItems: chargerMenuItems, // add this property
        onMenuItemClick: handleMenuItemClick,
        onChargerMenuItemClick: handleChargerMenuItemClick,
        dispatch: useDispatch<AppDispatch>(), // add this property
        isNewIndustry, // pass isNewIndustry
    });

    const logo = collapsed ? LogoSmall : LogoDark;

    const lastSegment = useMemo(() => {
        const currentPathSegments: any = location.pathname.split("/");
        let segment = currentPathSegments.at(-1);

        if (fuelId) {
            segment = FUEL;
        } else if (powerIdFromURL) {
            // Check if the path contains 'powerdiag' to distinguish between Power and PowerDiag
            const pathLower = location.pathname.toLowerCase();
            segment = pathLower.includes('powerdiag') ? POWER_DIAG : POWER_GENERATION;
        } else if (chargerIdFromURL) {
            segment = CHARGERS;
        }

        return capitalizeFirstLetter(segment);
    }, [location.pathname, fuelId, powerIdFromURL, chargerIdFromURL]);

    return { menuItems, lastSegment, logo };
}